
// ==========================================
// 4. src/components/sections/Hero.js
// ==========================================
import React from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import Button from '../common/Button';

const Hero = () => {
  const proofPoints = [
    'Proven Workflows',
    'Built by Industry Experts',
    'White Glove Support'
  ];

  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="absolute inset-0 bg-grid-pattern opacity-5"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-32">
        <div className="text-center max-w-4xl mx-auto">
          {/* Tagline */}
          <p className="text-blue-600 font-semibold mb-4 text-lg">
            For logistics companies drowning in manual work
          </p>

          {/* Main Heading */}
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
            Your dispatch, on{' '}
            <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              autopilot
            </span>
          </h1>

          {/* Subheading */}
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Moving freight shouldn’t take heroics—or double work. SYBR TMS seamlessly connects you with trading partners, integrates with your ELD/GPS,
            and leverages <b>Transportation Intelligence™</b> to ensure the right freight is matched with the right assets—automatically.
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              href="https://calendly.com/sybrtms/intro-call"
              variant="primary"
              target="_blank"
              style={{ zIndex: 10 }}
            >
              Book a Demo
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition" />
            </Button>
            <Button
              href="#how"
              variant="secondary"
              style={{ zIndex: 10 }}
            >
              See How It Works
            </Button>
          </div>

          {/* Social Proof */}
          <div className="mt-12 flex items-center justify-center gap-8 text-sm text-gray-500">
            {proofPoints.map((point, index) => (
              <div key={index} className="flex items-center gap-2">
                <CheckCircle className="w-5 h-5 text-green-500" />
                <span>{point}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;